var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "d-flex flex-column justify-content-between border-left h-100"
    },
    _vm._l(_vm.options, function(item, index) {
      return _c(
        "div",
        {
          key: `tab-item-${index}`,
          staticClass: "compact cursor-pointer",
          class: {
            "compact--active": item.active,
            compact__first: item.active && item.id === 0,
            compact__last: item.active && item.id === 3
          },
          on: {
            click: function($event) {
              return _vm.onSelect(index, item.tabKey)
            }
          }
        },
        [
          _c("em", {
            staticClass: "d-flex justify-content-center py-2",
            class: _vm.iconClass(item.icon)
          })
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }